// src/features/projects/hooks/useMyProjects.js

import { useState, useEffect, useCallback } from "react";
import axios from "axios";

export default function useMyProjects({ token, apiUrl }) {

  const [myProjects, setMyProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [projectsError, setProjectsError] = useState("");

  const fetchProjects = useCallback(async () => {

    if (!token) {
      setLoadingProjects(false);
      return;
    }

    try {

      setLoadingProjects(true);
      setProjectsError("");

      const res = await axios.get(
        `${apiUrl}/projects/my`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const projects = res.data.map(entry => {

        const project = entry.project || entry;
        const presentation = project.presentation || null;

        const groupName =
          entry.group?.name || null;

        const participantIdentifier =
          entry.participantIdentifier || null;

        let description =
          project.description || "";

        const extraInfo = [];

        if (groupName)
          extraInfo.push(`Group: ${groupName}`);

        if (extraInfo.length > 0)
          description =
            `${description}\n${extraInfo.join(" • ")}`;

        return {

          id: project._id,
          slug: project.slug,

          icon:
            project.dashboardConfig?.icon ||
            "isotypePositive",

          title:
            project.title ||
            project.name ||
            "Project",

          description,

          institutionalContext: presentation?.institutionalContext || null,
          visualIdentity: presentation?.visualIdentity || {
            source: "all_voiced",
            logo: null,
            externalBrand: null,
          },

          role: entry.role || null,

          participantIdentifier,

          footer: "Open project"

        };

      });

      setMyProjects(projects);

    } catch (err) {

      console.error("Error loading projects", err);
      setProjectsError(err?.message || "Could not load projects");

    } finally {

      setLoadingProjects(false);

    }

  }, [token, apiUrl]);

  // auto-load
  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return {
    myProjects,
    loadingProjects,
    projectsError,
    refreshProjects: fetchProjects
  };
}
